<!-- 发送结果 -->
<template>
  <div class="pane-div">
    <el-form label-width="130px"
             :inline="true"
             :model="dataForm">
      <el-row class="margb10">
        <!-- 抄送发件人 -->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('bulkmail.ccSender')"
                        style="width:100% !important">
            <el-checkbox v-model="dataForm.ccSender">{{$t('bulkmail.ccSender')}}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
        <!-- 邮件类型 -->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('bulkmail.mailType')"
                        style="width:100% !important">
            <el-select v-model="dataForm.mailType">
              <el-option v-for="(item,index) in mailType"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10" v-if="dataForm.mailType == '10'">
        <!-- 收件人组群 -->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('bulkmail.addresseeGroup')"
                        style="width:100% !important">
            <el-input v-model="dataForm.addresseeGroup"
                      type="text"
                      :placeholder="$t('bulkmail.addresseeGroup')"
                      clearable>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
        <!-- 拆分类型 -->
      <el-row class="margb10" v-if="dataForm.mailType == '20'">
        <!-- 收件人职位 -->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('bulkmail.addresseePosition')"
                        style="width:100% !important">
            <el-input v-model="dataForm.addresseePosition"
                      type="text"
                      :placeholder="$t('bulkmail.addresseePosition')"
                      clearable>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10" v-if="dataForm.mailType == '20'">
        <!-- 收件人角色 -->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('bulkmail.addresseeRole')"
                        style="width:100% !important">
            <el-input v-model="dataForm.addresseeRole"
                      type="text"
                      :placeholder="$t('bulkmail.addresseeRole')"
                      clearable>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
        <!-- 发送方式 -->
        <el-col :span="12"
                class="mar-b">
          <el-form-item :label="$t('bulkmail.sendType')"
                        style="width:100% !important">
            <el-select v-model="dataForm.sendType">
              <el-option v-for="(item,index) in sendType"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="search">
      <el-button type="primary"
                 @click="addToTable()">{{ $t('bulkmail.addToList') }}</el-button>
      <el-button type="primary" v-if="dataForm.mailType == '20'"
                 @click="addRouter()">{{ $t('bulkmail.add') }}</el-button>
    </div>
    <el-table  v-show="dataForm.mailType == '10'"
                v-loading="dataListLoading"
              :data="dataList1"
              border
              style="width: 80%;">
      <el-table-column type="index"
                       width="50"
                       :label="$t('bulkmail.no')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="sendType"
                       :formatter="sendTypeFormatter"
                       :label="$t('bulkmail.sendType')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="sendState"
                       :formatter="sendStateFormatter"
                       :label="$t('bulkmail.tableState')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="stateValue"
                       :label="$t('bulkmail.tableStateVal')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column :label="$t('handle')"
                       fixed="right"
                       header-align="center"
                       align="center"
                       width="150">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="deleteHandle1(scope.$index)">{{ $t('bulkmail.delete') }}</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-table  v-show="dataForm.mailType == '20'"
                v-loading="dataListLoading"
              :data="dataList2"
              border
              style="width: 80%;">
      <el-table-column type="index"
                       width="50"
                       :label="$t('bulkmail.no')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="sendType"
                       :formatter="sendTypeFormatter"
                       :label="$t('bulkmail.sendType')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="sendState"
                       :formatter="sendStateFormatter"
                       :label="$t('bulkmail.tableState')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="positionValue"
                       :label="$t('bulkmail.positionStateVal')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="roleValue"
                       :label="$t('bulkmail.roleStateVal')"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column :label="$t('handle')"
                       fixed="right"
                       header-align="center"
                       align="center"
                       width="150">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="deleteHandle2(scope.$index)">{{ $t('bulkmail.delete') }}</el-button>

        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/role/list',
        getDataListIsPage: false
      },
      dataForm: {
        sendType: '10',
        mailType: '10'
      },
      mailType: _this.enums['sendType'],
      sendType: _this.enums['sendToType'],
      dataList1: [],
      dataList2: [],
    }
  },
  components: {
  },
  methods: {
    // TODO 更换接口后删除此方法
    getDataList() {
      console.log('getDataList')
    },
    // 数据字典字段取值
    sendStateFormatter(row) {
      return Vue.filter('coverEnum')(row.sendState, 'sendType')
    },
    sendTypeFormatter(row) {

      return Vue.filter('coverEnum')(row.sendType, 'sendToType')
    },
    deleteHandle1(index) {
        this.dataList1.splice(index, 1)
    },
    deleteHandle2(index) {
         this.dataList2.splice(index, 1)
    },
    // 添加到列表
    addToTable(){
            console.log('in')
        var selectVal = this.dataForm.mailType
        // 群组发送
        if(selectVal == '10'){
            if(!this.dataForm.addresseeGroup || this.dataForm.addresseeGroup.trim() == ''){
                this.$alert('收件人组群不能为空')
                return false
            }
            this.dataList1.push({
                sendType: this.dataForm.sendType,
                sendState: this.dataForm.mailType,
                stateValue: this.dataForm.addresseeGroup
            })
        }
        // 拆分发送
        if(selectVal == '20'){
            if(!this.dataForm.addresseePosition || this.dataForm.addresseePosition.trim() == ''){
                this.$alert('收件人职位不能为空')
                return false
            }
            if(!this.dataForm.addresseeRole || this.dataForm.addresseeRole.trim() == ''){
                this.$alert('收件人角色不能为空')
                return false
            }
            this.dataList2.push({
                sendType: this.dataForm.sendType,
                sendState: this.dataForm.mailType,
                positionValue: this.dataForm.addresseePosition,
                roleValue: this.dataForm.addresseeRole
            })
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.pane-div {
  background: #fff;
  padding: 20px;
}
.margb10 {
  margin-bottom: 10px;
}
.search{
    width: 80%;
    overflow: hidden;
    position: relative;
    margin-bottom:10px;
    display: flex;
    justify-content: space-between;
}
</style>